function EmoteIcon(props)
{
    return(
        <svg className={props.class} viewBox="0 0 24 24"><path d="M12,16a4.045,4.045,0,0,0,3.225-1.632,1,1,0,1,1,1.55,1.264,6,6,0,0,1-9.55,0,1,1,0,0,1,1.55-1.264A4.045,4.045,0,0,0,12,16ZM1,12A11,11,0,1,1,12,23,11.013,11.013,0,0,1,1,12Zm2,0a9,9,0,1,0,9-9A9.01,9.01,0,0,0,3,12Zm11,0a1,1,0,0,0,1-1,1,1,0,0,1,2,0,1,1,0,0,0,2,0,3,3,0,0,0-6,0A1,1,0,0,0,14,12ZM7,11a1,1,0,0,1,2,0,1,1,0,0,0,2,0,3,3,0,0,0-6,0,1,1,0,0,0,2,0Z"/></svg>
    )
}

export default EmoteIcon